import {TaskType} from '../../../tasks/enums/TaskType';
import {ASSET_FORM_REQUIREMENT_COLLECTION} from '../../domain/config';
import {getCreateAssetFormRequirement} from '../../reducers/state';
import {makeEditFormReqModal} from '../config/configEditReqRequests';
import {CREATE_ASSET_FORM_PREFIX} from '../state';


export const {
  /** @type {ReduxRequestModal} */
  requestModal: createAssetFormRequirementRequestModal,
} = makeEditFormReqModal({
  isCreate: true,
  taskType: TaskType.ASSET,
  prefix: CREATE_ASSET_FORM_PREFIX,
  getState: getCreateAssetFormRequirement,
  path: ASSET_FORM_REQUIREMENT_COLLECTION,
});



// WEBPACK FOOTER //
// ./src/js/requirements/redux/forms/createAssetFormRequirement.js